import { api, apiOrigin } from '../api';
import { apiErrorMessage, responseErrorMessage } from '../utils/api-error';

export async function requestFileDownload(fileId: string) {
  const response = await api.api.api.v1.files({ id: fileId })['download-ticket'].post();
  if (response.error || !response.data) {
    throw new Error(
      apiErrorMessage(response.error, {
        fallback: 'Could not prepare the file for download.',
        status: response.status,
      }),
    );
  }
  const url = `${apiOrigin}${response.data.path}`;
  const readiness = await fetch(url, { method: 'HEAD', cache: 'no-store' });
  if (!readiness.ok) {
    throw new Error(await responseErrorMessage(readiness, 'The file cannot be downloaded.'));
  }
  return {
    url,
    expiresAt: new Date(response.data.expiresAt).getTime(),
  };
}
